import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Divider,
  Grid,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  FormHelperText
} from '@mui/material';
import { useFormContext } from './FormContext';

const Page2Assistant: React.FC = () => {
  const { 
    formData, 
    errors, 
    handleChange, 
    handleMultiSelectChange 
  } = useFormContext();

  return (
    <>
      <Typography variant="h6" gutterBottom sx={{ mt: 2, mb: 2, color: "primary.main" }}>
        Seção 2: A Personalidade do Assistente Virtual
      </Typography>
      <Typography variant="body2" gutterBottom sx={{ mb: 2, fontStyle: 'italic' }}>
        Aqui definimos como o seu assistente vai "falar" e se comportar.
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            id="assistantName"
            label="Que nome você gostaria de dar ao seu assistente virtual?"
            name="assistantName"
            value={formData.assistantName}
            onChange={handleChange}
            helperText='Opcional, mas ajuda a criar uma conexão. Ex: "Bia", "Max", "Assistente [Nome da Empresa]"'
          />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Qual deve ser o tom de voz do assistente? Escolha uma ou mais opções:
          </Typography>
          <FormControl component="fieldset" error={!!errors.toneOfVoice}>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox onChange={handleMultiSelectChange('toneOfVoice')} checked={formData.toneOfVoice.includes('super_friendly')} value="super_friendly" />}
                label="Super amigável e informal (usa gírias, emojis, bem descontraído)"
              />
              <FormControlLabel
                control={<Checkbox onChange={handleMultiSelectChange('toneOfVoice')} checked={formData.toneOfVoice.includes('friendly')} value="friendly" />}
                label="Amigável e prestativo (educado, mas casual)"
              />
              <FormControlLabel
                control={<Checkbox onChange={handleMultiSelectChange('toneOfVoice')} checked={formData.toneOfVoice.includes('professional')} value="professional" />}
                label="Profissional e direto (formal, objetivo, sem rodeios)"
              />
              <FormControlLabel
                control={<Checkbox onChange={handleMultiSelectChange('toneOfVoice')} checked={formData.toneOfVoice.includes('enthusiastic')} value="enthusiastic" />}
                label="Entusiasmado e vendedor (proativo, sugere produtos, cria empolgação)"
              />
              <FormControlLabel
                control={<Checkbox onChange={handleMultiSelectChange('toneOfVoice')} checked={formData.toneOfVoice.includes('caring')} value="caring" />}
                label="Acolhedor e paciente (calmo, explica tudo com detalhes)"
              />
            </FormGroup>
            {errors.toneOfVoice && (
              <FormHelperText error>{errors.toneOfVoice}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Uso de Emojis:
          </Typography>
          <FormControl component="fieldset" error={!!errors.emojiUsage}>
            <RadioGroup
              name="emojiUsage"
              value={formData.emojiUsage}
              onChange={handleChange}
            >
              <FormControlLabel value="yes" control={<Radio />} label="Sim, pode usar emojis para deixar a conversa mais leve." />
              <FormControlLabel value="moderate" control={<Radio />} label="Usar com moderação, apenas quando fizer sentido." />
              <FormControlLabel value="no" control={<Radio />} label="Não, prefiro uma comunicação sem emojis." />
            </RadioGroup>
            {errors.emojiUsage && (
              <FormHelperText error>{errors.emojiUsage}</FormHelperText>
            )}
          </FormControl>
        </Grid>

        <Grid item xs={12}>
          <Typography variant="subtitle1" gutterBottom>
            Como o assistente deve se dirigir ao cliente?
          </Typography>
          <FormControl component="fieldset" error={!!errors.clientAddressing}>
            <RadioGroup
              name="clientAddressing"
              value={formData.clientAddressing}
              onChange={handleChange}
            >
              <FormControlLabel value="informal" control={<Radio />} label='Usando "você" (mais comum e recomendado).' />
              <FormControlLabel value="formal" control={<Radio />} label='Usando "o senhor / a senhora" (mais formal).' />
            </RadioGroup>
            {errors.clientAddressing && (
              <FormHelperText error>{errors.clientAddressing}</FormHelperText>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
};

export default Page2Assistant;